// ----------------------------------------------------------------------
// <copyright file="Izenda.EditableInput.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var React = require('react');
  var domHelperEvents = require('dom-helpers/events');

  var EditableInput = React.createClass({

    getInitialState: function() {
      var props = this.props;

      return {
        value: String(props.value).toUpperCase(),
        blurValue: String(props.value).toUpperCase(),
      };
    },

    componentWillReceiveProps: function(nextProps) {
      var input = this.refs.input;

      if (nextProps.value !== this.state.value) {
        if (input === document.activeElement) {
          this.setState({ blurValue: String(nextProps.value).toUpperCase() });
        } else {
          this.setState({ value: String(nextProps.value).toUpperCase() });
        }
      }
    },

    componentWillUnmount: function() {
      this.unbindEventListeners();
    },

    handleBlur: function() {
      if (this.state.blurValue) {
        this.setState({ value: this.state.blurValue, blurValue: null });
      }
    },

    handleChange: function(e) {
      if (!!this.props.label) {
        this.props.onChange({
          [this.props.label]: e.target.value
        });
      } else {
        this.props.onChange(e.target.value);
      }

      this.setState({ value: e.target.value });
    },

    handleKeyDown: function(e) {
      var number = Number(e.target.value);
      if (number) {
        var amount = this.props.arrowOffset || 1;

        // Up
        if (e.keyCode === 38) {
          if (this.props.label !== null) {
            this.props.onChange({
              [this.props.label]: number + amount
            });
          } else {
            this.props.onChange(number + amount);
          }

          this.setState({ value: number + amount });
        }

        // Down
        if (e.keyCode === 40) {
          if (this.props.label !== null) {
            this.props.onChange({
              [this.props.label]: number - amount
            });
          } else {
            this.props.onChange(number - amount);
          }

          this.setState({ value: number - amount });
        }
      }
    },

    handleDrag: function(e) {
      if (this.props.dragLabel) {
        var newValue = Math.round(this.props.value + e.movementX);
        if (newValue >= 0 && newValue <= this.props.dragMax) {
          this.props.onChange({
            [this.props.label]: newValue
          });
        }
      }
    },

    handleMouseDown: function(e) {
      if (this.props.dragLabel) {
        e.preventDefault();
        this.handleDrag(e);
        domHelperEvents.on(window, 'mousemove', this.handleDrag);
        domHelperEvents.on(window, 'mouseup', this.handleMouseUp);
      }
    },

    handleMouseUp: function() {
      this.unbindEventListeners();
    },

    unbindEventListeners: function() {
      domHelperEvents.off(window, 'mousemove', this.handleDrag);
      domHelperEvents.off(window, 'mouseup', this.handleMouseUp);
    },

    render: function() {
      var inputClasses = (this.props.type === "hex") ? "izenda-EditableInput-hexInput" : "izenda-EditableInput-input";
      var labelClasses = (this.props.type === "hex") ? "izenda-EditableInput-hexLabel" : "izenda-EditableInput-label";

      return (
        <div className="u-posRelative izenda-EditableInput">
          <input
            className={inputClasses}
            ref="input"
            value={ this.state.value }
            onKeyDown={ this.handleKeyDown }
            onChange={ this.handleChange }
            onBlur={ this.handleBlur }
            placeholder={ this.props.placeholder }
          />
          { this.props.label ? 
            (
              <span className={labelClasses} onMouseDown={ this.handleMouseDown }>
                { this.props.label }
              </span>
            ) : null
          }
        </div>
      );
    }
  });

  module.exports = EditableInput;

}());



// WEBPACK FOOTER //
// ./ui/share/components/controls/ColorDialog/Izenda.EditableInput.jsx